// extracted by mini-css-extract-plugin
export default {"smile":"smile___aa0ddc13356e7fa4","small":"small___b08f329c282ea981","pack2":"pack2___d46217f534395206","pack3":"pack3___eba7af182fa230f9","large":"large___dc5e1cfb18afd32d"};